import React, { Component } from "react";
import { connect } from "react-redux"
import './index.scss';
import PropTypes from 'prop-types';
import { getOriginalFileService } from '../api/dlaapifunctions'
import appconfig from '../../config/oAuthConfig';

import moment from 'moment';
import saveAs from 'file-saver';
import * as constants from './dlaconstants'
import * as messages from './usermessage'
var path = require('path');

class FileList extends Component {
  constructor(props) {
    super(props);
    if (this.props.recentItemData.rowid !== 0) {
      this.state = {
        setClassName: "collapse"
      };
    } else {
      this.state = {
        setClassName: "collapse show"
      };
    }

  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.collapsAll !== this.props.collapsAll) {
      if (nextProps.collapsAll === true) {
        this.setState({
          setClassName: "collapse show"
        })

      } else if (nextProps.collapsAll === false) {
        this.setState({
          setClassName: "collapse"
        })
      }
    }

  }

  showHideFileItem () {

    if (this.state.setClassName === "collapse show") {
      this.setState({
        setClassName: "collapse"
      });

    } else {
      this.setState({
        setClassName: "collapse show"
      })
    }

  }
  trimFileName (str, length = 60) {

    var toset = str;
    if (str.length > length) {
      toset = str.substring(0, length) + '..';
    }

    return toset;

  }

  async downloadfile (filename, e, url, filestatus) {

    e.preventDefault();
    if (filestatus.indexOf('ERROR') > 0 || filestatus.indexOf('_SUCCESS_') > 0) {
      url = url + "-err.txt";
    }
    let blob;
    const fileObj = await getOriginalFileService(url, constants[appconfig.loaderType].contentType);
    if (filestatus.indexOf('ERROR') > 0 || filestatus === "IMPORT_SUCCESS_PARTIAL") {
      blob = new Blob([fileObj.data], { type: fileObj.headers["content-type"] });
      let basename = path.basename(filename, '.txt');
      saveAs(blob, "Error_" + basename + ".txt");
    } else if (filestatus === "IMPORT_SUCCESS_WARNING") {
      blob = new Blob([fileObj.data], { type: fileObj.headers["content-type"] });
      let basename = path.basename(filename, '.txt');
      saveAs(blob, "Warning_" + basename + ".txt");
    } else {
      blob = new Blob([fileObj.data], { type: fileObj.headers["content-type"] });
      saveAs(blob, filename);
    }
  }

  getStatusMessage (rowData) {

    if (rowData.statusFileLocation) {
      return <a key={rowData.UUID + "message"} href="error" className="col-md-6" onClick={(evt) => { this.downloadfile(rowData.fileName, evt, rowData.UUID, rowData.currentStatus) }}> {messages[rowData.currentStatus]} </a>
    } else
      if (rowData.statusFileLocation === "undef" || !rowData.statusFileLocation) {
        return <div key={rowData.UUID + "errDescription"} className="col-md-6">{messages[rowData.currentStatus]}</div>
      }

  }

  render () {

    let totalFilesImported = 0;
    let numberOfSuccessImports = 0;
    let numberOffailedImports = 0;
    let historyImportsCard = "";

    historyImportsCard = this.props.groubedByDateData.map(t => {
      //console.log("filestatus response.......",JSON.stringify(t,0,4))
      if (constants[t.currentStatus] === "Import Failed" || constants[t.currentStatus] === "Import Partially Successful") {
        numberOffailedImports = numberOffailedImports + 1;
      } else {
        numberOfSuccessImports = numberOfSuccessImports + 1;
      }

      totalFilesImported = totalFilesImported + 1;

      var date = moment(new Date(JSON.parse(t.timestamp))).format('hh:mm A');

      let listGroupItem = <li key={t.UUID} className="list-group-item">
        <div key={t.UUID + "div"} className="row">
          <a key={t.UUID + "filename"} className="text-primary col-md-7" href="filename" onClick={(evt) => { this.downloadfile(t.fileName, evt, t.UUID, "original") }}>{this.trimFileName(t.fileName)}</a>
          <div id="status-field" key={t.UUID + "status"} className="col-md-5 text-right">{constants[t.currentStatus]} </div>
        </div>

        <br></br>

        <div key={t.UUID + "status"} className="row">
          <div key={t.UUID + "filetype"} className="col-md-3"> {t.fileType} </div>

          {this.getStatusMessage(t)}

          <div key={t.UUID + "date"} className="col-md-3 text-right"> {date} </div>
        </div>


      </li>



      return (
        <div key={t.UUID + "listItem"}>
          {listGroupItem}
        </div>

      )
    })



    return (

      <div>
        <div onClick={() => { this.showHideFileItem() }} className="card-header ">{this.props.recentItemData.resultDate} ({totalFilesImported}) ‘{numberOfSuccessImports} successful, {numberOffailedImports} failed’ </div>
        <div className={this.state.setClassName}>
          {historyImportsCard}
        </div>
      </div>

    )
  }
}
FileList.propTypes = {
  data: PropTypes.object.isRequired


};
const mapStateToProps = state => ({
  data: state.gCache.data


}); export default React.memo(connect(
  mapStateToProps
)((FileList)));